"use client";

import { c as _c } from "react/compiler-runtime";
import { authCookieName } from "@/shared/config/auth-domain";
import { useEffect } from "react";
import { useTranslations } from "next-intl";
import Cookies from "js-cookie";
import { InterestSelectModalBody } from "@/features/home/ui";
import useDataStore from "@/features/home/model/data/store";
import { Typography, TextButton } from "@/shared/ui/atoms";
import Modal from "@/shared/ui/templates/Modal";
import { useMutationPostUserInterest } from "@/entities/user/hooks/useUser";
import { parseUserInfoCookie } from "@/shared/lib/user-info-cookie";
import { removeClientAuthCookie } from "@/shared/lib/client-auth-cookie";
const InterestSelectModal = t0 => {
  const $ = _c(44);
  const {
    open,
    onClose
  } = t0;
  const rawUserInfo = Cookies.get(authCookieName("userInfo"));
  const userInfo = parseUserInfoCookie(rawUserInfo);
  const userName = userInfo?.userName ?? "";
  const userInfoIsInvalid = Boolean(rawUserInfo && !userInfo);
  const {
    isViewInterestSelectModalIndex: ModalStep,
    setIsViewInterestSelectModalIndex
  } = useDataStore();
  const {
    interestTreatment,
    interestProcedure
  } = useDataStore();
  const {
    mutate: postUserInterest
  } = useMutationPostUserInterest();
  const t = useTranslations();
  let t1;
  let t2;
  if ($[0] !== userInfoIsInvalid) {
    t1 = () => {
      if (userInfoIsInvalid) {
        removeClientAuthCookie("userInfo");
      }
    };
    t2 = [userInfoIsInvalid];
    $[0] = userInfoIsInvalid;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== ModalStep || $[4] !== interestProcedure || $[5] !== onClose || $[6] !== postUserInterest || $[7] !== setIsViewInterestSelectModalIndex) {
    t3 = () => {
      if (ModalStep === 0) {
        setIsViewInterestSelectModalIndex(1);
      } else {
        postUserInterest(interestProcedure);
        setIsViewInterestSelectModalIndex(2);
        onClose();
      }
    };
    $[3] = ModalStep;
    $[4] = interestProcedure;
    $[5] = onClose;
    $[6] = postUserInterest;
    $[7] = setIsViewInterestSelectModalIndex;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const setInterest = t3;
  let t4;
  if ($[9] !== ModalStep || $[10] !== t) {
    t4 = ModalStep === 0 ? t("commonButtons.next") : t("commonButtons.complete");
    $[9] = ModalStep;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = ModalStep === 0 ? interestTreatment.length === 0 : interestProcedure.length === 0;
  let t6;
  if ($[12] !== setInterest || $[13] !== t4 || $[14] !== t5) {
    t6 = {
      text: t4,
      onClick: setInterest,
      className: "w-full py-3 bg-primary-600 text-white rounded-lg font-semibold disabled:bg-[#F7F7F7] disabled:text-[#989BA2] disabled:cursor-not-allowed",
      disabled: t5
    };
    $[12] = setInterest;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const textButtonProps = t6;
  const T0 = Modal;
  const t7 = "screen";
  const t8 = "0px";
  const t9 = "pb-[72px] px-4 overflow-y-auto";
  const t10 = "pb-5 flex flex-col";
  const t11 = ModalStep + 1;
  let t12;
  if ($[16] !== t11) {
    t12 = <Typography lineHeight={24} className="text-primary font-bold">{t11}/2</Typography>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const T1 = Typography;
  const t13 = 24;
  const t14 = 32;
  const t15 = "mt-2 mb-[14px] font-semibold";
  const t16 = t("commonInterestModal.welcome", {
    userName
  });
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <br />;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t) {
    t18 = t("commonInterestModal.question");
    $[19] = t;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] !== T1 || $[22] !== t16 || $[23] !== t18) {
    t19 = <T1 size={t13} lineHeight={t14} className={t15}>{t16} {t17} {t18}</T1>;
    $[21] = T1;
    $[22] = t16;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t) {
    t20 = t("commonInterestModal.description");
    $[25] = t;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t20) {
    t21 = <Typography lineHeight={24} className="text-[#171719]">{t20}</Typography>;
    $[27] = t20;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t12 || $[30] !== t19 || $[31] !== t21) {
    t22 = <div className={t10}>{t12}{t19}{t21}</div>;
    $[29] = t12;
    $[30] = t19;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <InterestSelectModalBody />;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== textButtonProps) {
    t24 = <div className="fixed w-[calc(100%-32px)] max-w-[600px] bottom-0 bg-white py-3"><TextButton {...textButtonProps} /></div>;
    $[34] = textButtonProps;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== t22 || $[37] !== t24) {
    t25 = <div className={t9}>{t22}{t23}{t24}</div>;
    $[36] = t22;
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== T0 || $[40] !== onClose || $[41] !== open || $[42] !== t25) {
    t26 = <T0 open={open} onClose={onClose} height={t7} round={t8}>{t25}</T0>;
    $[39] = T0;
    $[40] = onClose;
    $[41] = open;
    $[42] = t25;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  return t26;
};
export default InterestSelectModal;